<template>
  <a-spin size="large" style="margin: 10vh" :spinning="pageLoading">
    <div v-if="showPage">
      <el-page-header :icon="LeftOutlined" :content="operationCode === 'add' ? '新建需求' : '需求详情'" class="page-header"
        @back="goBack">
        <template #title>返回</template>
      </el-page-header>
      <a-card :bordered="false">
        <!-- 可折叠容器 -->
        <a-collapse :default-active-key="['form', 'table']">
          <!-- 表单区域 -->
          <a-collapse-panel key="form" header="需求基本信息" style="text-align: left;">
            <!-- 打开表单级别的 autofill 支持 -->
            <a-form ref="formRef" :model="form" :rules="rules" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }"
              class="aligned-form" autocomplete="on">
              <a-row :gutter="24">
                <!-- 第一行 -->
                <a-col :xs="24" :sm="12" :md="8">
                  <a-form-item label="需求编号" name="requestNumber" disabled>
                    <a-input v-model:value="form.requestNumber" placeholder="提交后生成" disabled autocomplete="off" />
                  </a-form-item>
                </a-col>

                <a-col :xs="24" :sm="12" :md="8">
                  <a-form-item label="所属PMC" name="project" required>
                    <a-select v-model:value="form.project" placeholder="请选择PMC" :disabled="!authEdit"
                      :showArrow="authEdit" autocomplete="off">
                      <a-select-option v-for="item in Object.keys(PMCMap)" :key="item" :value="item">
                        {{ PMCMap[item] || item }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :xs="24" :sm="12" :md="8">
                  <!-- 子项目：允许浏览器尝试填充（使用 organization 作为近似 token） -->
                  <a-form-item label="子项目" name="subProject" required>
                    <a-input v-model:value="form.subProject" :maxlength="100" :show-count="authEdit"
                      placeholder="请输入子项目" :disabled="!authEdit" autocomplete="organization" />
                  </a-form-item>
                </a-col>

                <!-- 第二行 -->
                <a-col :xs="24" :sm="12" :md="8">
                  <a-form-item label="需求标题" name="title" required>
                    <a-input v-model:value="form.title" :maxlength="500" :show-count="authEdit" placeholder="请输入需求标题"
                      :disabled="!authEdit" autocomplete="off" />
                  </a-form-item>
                </a-col>

                <a-col :xs="24" :sm="12" :md="8">
                  <!-- 需求负责人：使用标准 token name 触发个人姓名类自动填充 -->
                  <a-form-item label="需求负责人" name="owner" required>
                    <a-input v-model:value="form.owner" :maxlength="100" :show-count="authEdit" placeholder="请输入负责人"
                      :disabled="!authEdit" autocomplete="name" />
                  </a-form-item>
                </a-col>

                <a-col :xs="24" :sm="12" :md="8">
                  <a-form-item label="当前状态" name="status" required>
                    <a-select v-model:value="form.status" placeholder="请选择状态" :disabled="!authEdit"
                      :showArrow="authEdit" autocomplete="off">
                      <a-select-option v-for="item in Object.keys(statusMap)" :key="item" :value="item">
                        <a-tag :color="statusColorMap[item] || 'default'">
                          {{ statusMap[item] || item }}
                        </a-tag>
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <!-- 第三行 -->
                <a-col :xs="24" :sm="12" :md="8">
                  <a-form-item label="预估工作量" name="workload" required>
                    <a-input-number v-model:value="form.workload" :min="0" :precision="2" addon-after="人月"
                      placeholder="请输入工作量" style="width: 100%" :disabled="!authEdit" autocomplete="off" />
                  </a-form-item>
                </a-col>

                <a-col :xs="24" :sm="12" :md="8">
                  <a-form-item label="版本" name="version" required>
                    <a-select v-model:value="form.version" placeholder="请选择版本" :disabled="!authEdit"
                      :showArrow="authEdit">
                      <a-select-option v-for="(value, key) in versionMap" :key="key" :value="key">
                        {{ value || key }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :xs="24" :sm="12" :md="8">
                  <a-form-item label="需求锁定时间" name="estimatedLockedDate" required>
                    <a-date-picker v-if="authEdit" v-model:value="form.estimatedLockedDate" format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD" placeholder="请选择时间" style="width: 100%" autocomplete="off" />
                    <a-input v-else v-model:value="form.estimatedLockedDate" placeholder="请选择时间" disabled
                      autocomplete="off" />
                  </a-form-item>
                </a-col>

                <!-- 第四行 -->
                <a-col :xs="24" :sm="12" :md="8">
                  <a-form-item label="需求转测时间" name="estimatedTransitionDate" required>
                    <a-date-picker v-if="authEdit" v-model:value="form.estimatedTransitionDate" format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD" placeholder="请选择时间" style="width: 100%" autocomplete="off" />
                    <a-input v-else v-model:value="form.estimatedTransitionDate" placeholder="请选择时间" disabled
                      autocomplete="off" />
                  </a-form-item>
                </a-col>

                <a-col :xs="24" :sm="12" :md="8">
                  <a-form-item label="需求完成时间" name="estimatedDeliveryDate" required>
                    <a-date-picker v-if="authEdit" v-model:value="form.estimatedDeliveryDate" format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD" placeholder="请选择时间" style="width: 100%" autocomplete="off" />
                    <a-input v-else v-model:value="form.estimatedDeliveryDate" placeholder="请选择时间" disabled
                      autocomplete="off" />
                  </a-form-item>
                </a-col>

                <a-col :xs="24" :sm="12" :md="8">
                  <a-form-item label="需求描述" name="detail" required>
                    <a-textarea v-model:value="form.detail" :maxlength="1000" :show-count="authEdit"
                      placeholder="请输入需求描述" :disabled="!authEdit" autocomplete="off" />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-collapse-panel>

          <!-- 表格区域 -->
          <a-collapse-panel key="table" header="现有意向承接单位" v-if="showTable" style="text-align: left;">
            <a-table :columns="columns" :data-source="tableData" :pagination="false" :scroll="{ y: 200 }" size="small">
              <template #bodyCell="{ column, record }">
                <template v-if="column.dataIndex === 'partnerPocNickName'">
                  <a-spin size="small" :spinning="record.spinning">
                    {{ record.partnerPocNickName }}
                  </a-spin>
                </template>
                <template v-if="column.dataIndex === 'contact'">
                  <a-spin size="small" :spinning="record.spinning">
                    {{ record.contact }}
                  </a-spin>
                </template>
                <template v-if="column.dataIndex === 'finalUndertakingFlag'">
                  <a-radio-group v-model:value="record.finalUndertakingFlag" :disabled="!authLock">
                    <a-radio value="Y">是</a-radio>
                    <a-radio value="N">否</a-radio>
                  </a-radio-group>
                </template>
              </template>
            </a-table>
          </a-collapse-panel>
        </a-collapse>

        <!-- 底部操作按钮 -->
        <div class="footer-actions">
          <a-button type="primary" @click="handleLock" :loading="locking" v-if="authLock">
            <template #icon>
              <LockOutlined />
            </template>
            锁定
          </a-button>
          <a-button type="primary" @click="handleSubmit" :loading="submitting" class="ml-3" v-if="authSubmit">
            <template #icon>
              <CloudUploadOutlined />
            </template>
            提交
          </a-button>
          <a-button type="primary" @click="handleReceive" v-if="authReceive">
            <template #icon>
              <CheckSquareOutlined />
            </template>
            预承接
          </a-button>
        </div>
      </a-card>
    </div>
  </a-spin>

  <a-result v-if="showSubmitSuccess" status="success" title="提交成功" :sub-title="successSubtitle">
    <template #extra>
      <a-space>
        <a-button type="primary" @click="goHome">
          主页
        </a-button>
      </a-space>
    </template>
  </a-result>

  <a-result v-if="showReceiveSuccess" status="success" title="预承接成功" sub-title="— 意向承接单位已更新 —">
    <template #extra>
      <a-space>
        <a-button type="primary" @click="goHome">
          主页
        </a-button>
      </a-space>
    </template>
  </a-result>

  <a-result v-if="showLockSuccess" status="success" title="完成" sub-title="— 需求已锁定 —">
    <template #extra>
      <a-space>
        <a-button type="primary" @click="goHome">
          主页
        </a-button>
      </a-space>
    </template>
  </a-result>

</template>

<script>
import axios from 'axios';
import { Modal, notification } from 'ant-design-vue';
import {
  CheckSquareOutlined,
  LockOutlined,
  CloudUploadOutlined,
  ExclamationCircleOutlined,
  LeftOutlined
} from '@ant-design/icons-vue';
import { Collapse } from 'ant-design-vue';
import { createVNode } from 'vue';
import openAtomApi from '@/openAtomApi';

const { Panel } = Collapse;

export default {
  components: {
    CheckSquareOutlined,
    LockOutlined,
    CloudUploadOutlined,
    ACollapse: Collapse,
    ACollapsePanel: Panel
  },
  data() {
    return {
      LeftOutlined,
      versionMap: {},
      PMCMap: {},
      user: {},
      token: null,
      opRequestHeaderId: null,
      operationCode: null,
      statusMap: {},
      statusColorMap: {
        'R_PROPOSAL': '#7FB6FF',
        'R_COOPERATION': '#6EE7B7',
        'R_DEVELOPMENT': '#FFB57C',
        'R_TESTING': '#C7A5FF',
        'R_COMPLETION': '#4CAF50',
        'R_CANCELLATION': '#FF4D4F'
      },
      authReceive: false,
      authLock: false,
      authEdit: false,
      authSubmit: false,
      pageLoading: true,
      showPage: false,
      showTable: true,
      showSubmitSuccess: false,
      showLockSuccess: false,
      showReceiveSuccess: false,
      successSubtitle: "",
      form: {},
      formRef: null,
      pocLoading: false,
      rules: {
        project: [{ required: true, message: '请选择所属PMC', trigger: 'change' }],

        subProject: [
          { required: true, message: '请输入子项目', trigger: 'blur' },
          { max: 100, message: '子项目名称不能超过100个字符', trigger: 'blur' }
        ],

        title: [
          { required: true, message: '请输入需求标题', trigger: 'blur' },
          { max: 500, message: '需求标题不能超过500个字符', trigger: 'blur' }
        ],

        owner: [
          { required: true, message: '请输入需求负责人', trigger: 'blur' },
          { max: 100, message: '负责人姓名不能超过100个字符', trigger: 'blur' }
        ],

        status: [{ required: true, message: '请选择当前状态', trigger: 'change' }],

        workload: [
          {
            validator: (_, value) => {
              // 必填校验
              if (value === null || value === undefined || value === '' || isNaN(value)) {
                return Promise.reject(new Error('请输入预估工作量'));
              }
              const num = Number(value);
              if (num < 0) {
                return Promise.reject(new Error('预估工作量不能为负数'));
              }
              const str = num.toString();
              const parts = str.split('.');
              if (parts[0].length > 20 || (parts[1] && parts[1].length > 18)) {
                return Promise.reject(new Error('工作量数值超出系统支持范围'));
              }

              return Promise.resolve();
            },
            trigger: 'blur'
          }
        ],

        version: [{ required: true, message: '请选择版本', trigger: 'change' }],

        estimatedLockedDate: [
          { required: true, message: '请选择需求锁定时间', trigger: 'change' }
        ],

        estimatedTransitionDate: [
          { required: true, message: '请选择需求转测时间', trigger: 'change' },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              const lockedDate = this.form.estimatedLockedDate;
              if (lockedDate && value < lockedDate) {
                return Promise.reject(new Error('需求转测时间不能早于需求锁定时间'));
              }
              return Promise.resolve();
            },
            trigger: 'change'
          }
        ],

        estimatedDeliveryDate: [
          { required: true, message: '请选择需求完成时间', trigger: 'change' },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              const transitionDate = this.form.estimatedTransitionDate;
              if (transitionDate && value < transitionDate) {
                return Promise.reject(new Error('需求完成时间不能早于需求转测时间'));
              }
              return Promise.resolve();
            },
            trigger: 'change'
          }
        ],

        detail: [
          { required: true, message: '请输入需求描述', trigger: 'blur' },
          { max: 1000, message: '需求描述不能超过1000个字符', trigger: 'blur' }
        ]
      },
      columns: [
        {
          title: '意向承接单位',
          dataIndex: 'partnerName',
          width: '25%',
        },
        {
          title: '单位接口人',
          dataIndex: 'partnerPocNickName',
          width: '25%',
        },
        {
          title: '接口人联系方式',
          dataIndex: 'contact',
          width: '25%',
        },
        {
          title: '是否最终承接单位',
          dataIndex: 'finalUndertakingFlag',
          width: '25%',
        }
      ],
      tableData: [],
      locking: false,
      submitting: false
    };
  },
  async created() {
    this.operationCode = this.$route.params.operationCode;
    this.opRequestHeaderId = this.$route.params.id;
    const operations = ['detail', 'edit', 'lock', 'add'];
    if (!operations.includes(this.operationCode) || !this.opRequestHeaderId
      || (this.operationCode === 'add' && this.opRequestHeaderId != -1)) {
      this.$router.push('/404');
    }

    await this.authorize();
    // await this.AUTHORIZE_FORCE();

    // authorization succeed <--> this.showPage === true
    try {
      if (this.showPage) {
        this.pageLoading = true;
        await Promise.all([
          this.fetchLookupData('OP_PMC', this.PMCMap),
          this.fetchLookupData('OP_VERSION', this.versionMap),
          this.fetchLookupData('OP_RE_STATUS', this.statusMap)
        ]);
        this.pageLoading = false;
        if (this.operationCode !== 'add') {
          await this.loadData();
        } else {
          this.form.opRequestHeaderId = null;
          this.form.requestNumber = null;
        }
      }
      window.scrollTo(0, 0);
    } catch {
      this.$router.push('/500');
    }
  },
  methods: {
    async authorize() {
      try {
        const openAtomRes = await openAtomApi.get('/user/info');
        this.user.login = openAtomRes.data?.login;
        this.user.id = openAtomRes.data?.id;
        this.user.name = openAtomRes.data?.name;
        if (this.operationCode === 'detail') {
          const res = await axios.post('/requestHeader/checkPermissions', null, {
            params: {
              userId: this.user.id,
              opRequestHeaderId: this.opRequestHeaderId,
              operationCode: 'RECEIVE',
            }
          });
          this.pageLoading = false;
          if (res.data.code !== 200) {
            throw new Error(res.data.desc);
          }
          this.showPage = true;
          if (res.data.data) {
            this.authReceive = true;
          }
          this.pageLoading = false;
          this.showPage = true;
        } else {
          const res = await axios.post('/requestHeader/checkPermissions', null, {
            params: {
              userId: this.user.id,
              opRequestHeaderId: this.opRequestHeaderId,
              operationCode: this.operationCode.toUpperCase(),
            }
          });
          this.pageLoading = false;
          if (res.data.code !== 200) {
            throw new Error(res.data.desc);
          }
          if (!res.data.data) {
            this.$router.push('/403');
          }
          this.showPage = true;
          if (this.operationCode === 'edit') {
            this.authEdit = true;
            this.authSubmit = true;
          } else if (this.operationCode === 'lock') {
            this.authLock = true;
          } else if (this.operationCode === 'add') {
            this.authEdit = true;
            this.authSubmit = true;
            this.showTable = false;
          }
        }
      } catch (error) {
        console.error(error);
        if (error.status === 403) {
          this.authShowProhibition = true;
          this.pageLoading = false;
        } else {
          this.pageLoading = false;
          this.$router.push('/500');
        }
      }
    },
    async AUTHORIZE_FORCE() {
      const openAtomRes = await openAtomApi.get('/user/info');
      this.user.login = openAtomRes.data?.login;
      this.user.id = openAtomRes.data?.id;
      this.user.name = openAtomRes.data?.name;
      this.pageLoading = false;
      this.showPage = true;
      if (this.operationCode === 'detail') {
        this.authReceive = true;
      } else if (this.operationCode === 'edit') {
        this.authEdit = true;
        this.authSubmit = true;
      } else if (this.operationCode === 'lock') {
        this.authLock = true;
      } else if (this.operationCode === 'add') {
        this.authEdit = true;
        this.authSubmit = true;
        this.showTable = false;
      }
    },
    async loadData() {
      this.pageLoading = true;
      try {
        const res = await axios.get('/requestHeader/getDemandPartnerByID', {
          params: {
            opRequestHeaderId: this.opRequestHeaderId,
          }
        });
        this.pageLoading = false;
        if (res.data.code !== 200) {
          throw new Error(res.data.desc);
        }
        this.form = res.data.data.opRequestHeaderVO;
        this.tableData = res.data.data.opRequestPartnerVOList.map(item => ({
          ...item,
          spinning: false
        }));

        this.tableData.forEach(async (item) => {
          item.spinning = true;
          openAtomApi.get(`/users/${item.partnerPocName}`)
            .then((res) => {
              const userInfo = res.data || {};
              item.partnerPocNickName = userInfo.name || '';
              item.contact = userInfo.phone || userInfo.email || '';
            })
            .catch((error) => {
              console.error(error);
              item.partnerPocNickName = `未找到用户@${item.partnerPocName}`;
              item.contact = `未找到用户@${item.partnerPocName}`;
            })
            .finally(() => {
              item.spinning = false;
            })
        });
      } catch (error) {
        this.pageLoading = false;
        notification.error({
          message: '加载数据失败',
          description: error,
        });
      }
    },
    handleReceive() {
      const hidePageAndShowReceiveSuccess = () => {
        this.showPage = false;
        this.showReceiveSuccess = true;
      };
      const userId = this.user.id;
      const opRequestHeaderId = this.opRequestHeaderId;
      Modal.confirm({
        title: '预承接后不可取消，请确认是否继续？',
        icon: createVNode(ExclamationCircleOutlined),
        content: '需求标题：' + this.form.title,
        okText: '确认',
        cancelText: '取消',
        async onOk() {
          try {
            const res = await axios.post('/requestHeader/preAcceptDemand', null, {
              params: {
                userId,
                opRequestHeaderId
              }
            });
            if (res.data.code !== 200) {
              throw new Error(res.data.desc);
            }
            hidePageAndShowReceiveSuccess();
          } catch (error) {
            notification.error({
              message: '预承接需求失败',
              description: error,
            });
          }
        },
        onCancel() { },
      });
    },

    async handleLock() {
      try {
        const valid = await this.$refs.formRef.validate();
        if (!valid) return;

        this.locking = true;
        const res = await axios.post('/requestHeader/lockDemand', {
          opRequestHeaderVO: this.form,
          opRequestPartnerVOList: this.tableData,
        });

        if (res.data.code === 200) {
          this.showPage = false;
          this.showLockSuccess = true;
        } else {
          throw new Error(res.data.desc);
        }
      } catch (error) {
        notification.error({
          message: '提交失败',
          description: error
        });
      } finally {
        this.locking = false;
      }
    },

    async handleSubmit() {
      try {
        try {
          await this.$refs.formRef.validate();
        } catch (error) {
          throw new Error('表单验证未通过，请检查输入项');
        }
        this.submitting = true;
        const res = await axios.post('/requestHeader/createOrUpdateDemand', {
          opRequestHeaderVO: this.form,
          opRequestPartnerVOList: this.tableData,
        });

        if (res.data.code === 200) {
          if (this.operationCode === 'add')
            this.successSubtitle = `需求编号：${res.data.data.opRequestHeaderVO.requestNumber}`;
          this.showPage = false;
          this.showSubmitSuccess = true;
        } else {
          throw new Error(res.data.desc);
        }
      } catch (error) {
        notification.error({
          message: '提交失败',
          description: error
        });
      } finally {
        this.submitting = false;
      }
    },

    async fetchLookupData(lookupType, targetMap) {
      const res = await axios.post('/requestHeader/queryLookup', null, {
        params: {
          lookupType,
          lookupCode: '',
          language: this.language || 'zh'
        }
      });
      if (res.data.code !== 200) {
        throw new Error(res.data.desc);
      }
      const dataList = res.data.data || [];
      dataList.forEach(item => {
        targetMap[item.lookupCode] = item.lookupValue;
      });
    },

    goBack() {
      window.history.back();
    },

    goHome() {
      this.$router.push('/demand-platform/home');
    },

    reloadPage() {
      location.reload();
    }
  },
};
</script>

<style scoped>
.page-header {
  margin-top: 15px;
  margin-left: 25px
}

.ant-form-item {
  margin-bottom: 25px;
}

/* 表单标签样式 */
.ant-form-item-label label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

/* 输入控件统一高度 */
.ant-input,
.ant-select .ant-select-selector,
.ant-input-number,
.ant-picker {
  height: 36px;
  border-radius: 4px;
}

/* 文本左对齐 */
.ant-input,
.ant-input-number-input {
  text-align: left;
}

/* 需求描述文本框 */
.ant-input-textarea textarea {
  min-height: 100px;
  resize: vertical;
}

/* 单位样式 */
.ant-input-number-addon {
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 14px;
  color: #666;
  line-height: 34px;
}

/* 折叠面板标题 */
:deep(.ant-collapse-header) {
  font-weight: 600;
  color: #1d39c4;
  line-height: 1.3;
  min-height: auto;
  height: auto;
}

/* 折叠面板内容：大幅减小上下内边距 */
:deep(.ant-collapse-content-box) {
  padding: 12px 0;
}

:deep(.ant-select-selection-item),
:deep(.ant-select-selection-placeholder),
:deep(.ant-form-item-explain) {
  text-align: left;
}

/* 底部按钮区域：减少上边距 */
.footer-actions {
  margin-top: 16px;
  text-align: center;
}

.footer-actions .ant-btn {
  margin: 0 8px;
}

.table-header {
  text-align: right;
  margin-bottom: 5px;
}

/* 响应式：小屏下也保持紧凑 */
@media (max-width: 768px) {
  .ant-form-item {
    margin-bottom: 18px;
  }

  .ant-form-item-label label {
    font-size: 13px;
  }
}
</style>